import { render, staticRenderFns } from "./TotpResetLink.vue?vue&type=template&id=4921766b&"
import script from "./TotpResetLink.vue?vue&type=script&lang=js&"
export * from "./TotpResetLink.vue?vue&type=script&lang=js&"
import style0 from "./TotpResetLink.vue?vue&type=style&index=0&id=4921766b&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports